// src/pages/salaryPaymentReport/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import SalaryPaymentReportFilters from "./components/SalaryPaymentReportFilters";
import SalaryPaymentReportTable from "./components/SalaryPaymentReportTable";
import { fetchSalaryPaymentReport } from "./SalaryPaymentReportThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportSalaryPaymentReportCsv } from "./components/exportSalaryPaymentReportCsv";

const { Title } = Typography;

const SalaryPaymentReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  useEffect(() => {
    dispatch(fetchSalaryPaymentReport({})); // initial load
  }, [dispatch]);
  const { filters, list } = useSelector(
    (state) => state.salaryPaymentReport
  );

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Salary Payment Report",
    removeAfterPrint: true,
    pageStyle: "@page { size: A4 landscape; margin: 12mm; }",
  });
  const handleDownloadCsv = () => {
    exportSalaryPaymentReportCsv({
      list,
      filters,
      title:    "Salary Payment Report",
      filename: "salary_payment_report",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="salary-payment-report-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>
                Salary Payment Report
              </Title>
            </Flex>
          }
         extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <SalaryPaymentReportFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <SalaryPaymentReportTable />
        </Card>
      </App>

      {/* Hidden Print Layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Salary Payment Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <SalaryPaymentReportTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default SalaryPaymentReport;
